import React, { useState } from 'react';
import FakePagination from '../../../../../components/Common/UI/FakePagination';
import { AccountManagementRes, IAccountManagementCol } from '../columns';
import Icons from '../../../../../components/Common/Icons/Icons';
import { Button } from '../../../../../components/Common/UI/Button';
import { cn } from '../../../../../utils/styles';
import CustomSubTable from './SubTable';

interface ICustomTable {
  data: AccountManagementRes[];
  columns: IAccountManagementCol[];
}

const defaultActiveRows = ['dd8080501', 'na8080502', 'sv8080503', 'td8080504'];

function CustomTable({ data, columns }: ICustomTable) {
  const [activeRows, setActiveRows] = useState<string[]>(defaultActiveRows);

  const handleToggleActiveRow = (payload: string) => {
    if (activeRows.includes(payload)) {
      setActiveRows(activeRows.filter(el => el !== payload));

      return;
    }

    setActiveRows([...activeRows, payload]);
  };

  return (
    <div>
      <div className="flex items-center justify-between px-[20px] py-2">
        <FakePagination value={data.length ? '1-4 of 4' : '0-0 of 0'} disabled />
      </div>
      <div className="grid grid-cols-3 h-[40px] bg-[#e2e4e7] text-sm font-medium text-label items-center border-b">
        {columns.map(({ name, id, enableSorting }, index) => (
          <div key={id} className={cn('flex gap-[5px] items-center', { 'pl-[80px]': index === 0 })}>
            {name}
            {enableSorting ? <Icons.SortIcon className="cursor-pointer" /> : null}
          </div>
        ))}
      </div>
      {data.length ? (
        data.map((el, index) => (
          <div key={`${index + el.accountNumber}`}>
            <div className="bg-slate-100">
              <a
                href="#"
                className="grid grid-cols-3 h-[60px] font-medium items-center border-b transition
                 hover:translate-x-[-10px]"
                onClick={e => {
                  e.preventDefault();
                  handleToggleActiveRow(el.id);
                }}
              >
                <div className="flex gap-[10px] items-center pl-[40px]">
                  <Button size="icon" variant="outline" className="bg-transparent w-[30px] h-[30px]">
                    <Icons.PlusMinusAnimated
                      active={!activeRows.includes(el.id)}
                      className="text-primary w-[13px] h-[13px]"
                    />
                  </Button>
                  {el.accountNumber}
                </div>
                <div>{el.accountType}</div>
                <div>{el.accountName}</div>
              </a>
            </div>
            <div className="mx-[40px]">
              {el.subRows.length ? <CustomSubTable item={el} activeRows={activeRows} /> : null}
            </div>
          </div>
        ))
      ) : (
        <div className="text-sm text-primary text-center my-[20px]">No search result</div>
      )}
    </div>
  );
}

export default CustomTable;
